import React from 'react';

import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import { WarehouseFlowSchema } from '@app/models/orders';
import { formatDateAndTimeShort } from '@app/services/date';
import { ListItem } from '@components/ListItem';
import { WarehouseErrorMarker } from '@components/orders';

interface IProps {
  flow: WarehouseFlowSchema;
}

export const WarehouseFlowTag: React.FC<IProps> = ({ flow }) => {
  const navigate = useNavigate();
  const orderT = useTranslation(NSKeys.order);

  const renderDocumentNumber = () => {
    if (!flow.external_document_number) {
      return '—';
    }

    // Глубокая ссылка имеет смысл только когда есть и склад, и номер: тогда мы
    // можем приземлить пользователя в нужную вкладку с уже применённым фильтром.
    if (!flow.warehouse_uid) {
      return flow.external_document_number;
    }

    const target = `/dashboard/warehouses/${flow.warehouse_uid}/shipments?q=${encodeURIComponent(
      flow.external_document_number
    )}`;

    return (
      <Typography.Link
        onClick={(event) => {
          event.stopPropagation();
          navigate(target);
        }}>
        {flow.external_document_number}
      </Typography.Link>
    );
  };

  return (
    <>
      <ListItem title={orderT.t('blockWarehouseFlow.fields.external_document_number')} description={null}>
        {renderDocumentNumber()}
      </ListItem>
      <ListItem
        title={orderT.t('blockWarehouseFlow.fields.sync_state')}
        description={orderT.t(`blockWarehouseFlow.sync_state.${flow.sync_state}` as any)}
      />
      <ListItem
        title={orderT.t('blockWarehouseFlow.fields.picking_at')}
        description={formatDateAndTimeShort(flow.picking_at || undefined)}
      />
      <ListItem
        title={orderT.t('blockWarehouseFlow.fields.assembled_at')}
        description={formatDateAndTimeShort(flow.assembled_at || undefined)}
      />
      <ListItem
        title={orderT.t('blockWarehouseFlow.fields.shipped_at')}
        description={formatDateAndTimeShort(flow.shipped_at || undefined)}
      />
      {flow.last_error_message && (
        <ListItem title={orderT.t('blockWarehouseFlow.fields.last_error_message')} description={null}>
          <WarehouseErrorMarker error={flow.last_error_message} />
        </ListItem>
      )}
    </>
  );
};
